export default __webpack_public_path__ + "static/media/Thought Gear Accelerate.8beb9064.png";